import { authedAxios } from "../utils/customHttpHeader";
import moment from "moment";

const getSaleReports = async (payload) => {
  const queryString = `report/sales?hotelIds=${payload.hotelIds}&startDate=${payload.startDate}&endDate=${payload.endDate}`;
  const response = await authedAxios().get(queryString);
  return response;
};

const nightAuditReportService = async (payload) => {
  const queryString = `report/nightAudit?hotelIds=${payload.hotelIds}&date=${payload.startDate}`;
  const response = await authedAxios().get(queryString);
  return response;
};

const getSettlementReportsService = async (payload) => {
  let path = `report/settlement-report?hotelIds=${payload.hotelIds}`;

  if (payload?.date) {
    path += `&date=${payload.date}`;
  }

  const response = await authedAxios().get(path);
  return response;
};

const getBookingListReportsService = async (payload) => {
  let path = `report/bookingList?hotelIds=${payload.hotelIds}&statuses=${payload.statuses}`;

  if (payload?.startDate) {
    path += `&startDate=${payload.startDate}`;
  }

  if (payload?.endDate) {
    path += `&endDate=${payload.endDate}`;
  }

  if (payload?.startDate) {
    path += `&startDate=${payload.startDate}`;
  }

  if (payload?.earlyCheckIn) {
    path += `&earlyCheckIn=${payload.earlyCheckIn}`;
  }
  if (payload?.lateCheckout) {
    path += `&lateCheckout=${payload.lateCheckout}`;
  }

  const response = await authedAxios().get(path);
  return response;
};

const getRoomChangeReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelIds=${payload?.hotelIds}`;

  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;

  const response = await authedAxios().get(url);
  return response;
};

const getOccupancyReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelIds=${payload?.hotelIds}`;

  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;

  const response = await authedAxios().get(url);
  return response;
};

const getSalesByCustomerReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelId=${payload?.hotelId}`;

  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;

  const response = await authedAxios().get(url);
  return response;
};

const getBookingSourceReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelIds=${payload?.hotelIds}`;

  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;

  const response = await authedAxios().get(url);
  return response;
};

const getTaxDetailsReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelIds=${payload?.hotelIds}`;

  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;
  if (payload?.invoiceType) url += `&invoiceType=${payload?.invoiceType}`;
  if (payload?.posId) url += `&posId=${payload?.posId}`;
  if (typeof payload?.taxIncludedInPrice === "boolean")
    url += `&taxIncludedInPrice=${payload?.taxIncludedInPrice}`;
  if (payload?.partyIds) url += `&partyIds=${payload?.partyIds}`;

  const response = await authedAxios().get(url);
  return response;
};

const getPayableReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelIds=${payload?.hotelIds}`;

  const response = await authedAxios().get(url);
  return response;
};

const getReceivableReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelIds=${payload?.hotelIds}`;

  const response = await authedAxios().get(url);
  return response;
};

const getPaymentReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelIds=${payload?.hotelIds}`;

  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;
  if (payload?.paymentMethod) url += `&paymentMethod=${payload?.paymentMethod}`;
  if (payload?.invoiceType) url += `&invoiceType=${payload?.invoiceType}`;
  if (payload?.posId) url += `&posId=${payload?.posId}`;

  const response = await authedAxios().get(url);
  return response;
};

const getVendorSummaryReportService = async (endpoint, payload) => {
  let url = endpoint;
  url += `?hotelId=${payload?.hotelId}`;

  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;
  if (payload?.expenseAccount)
    url += `&expenseAccount=${payload?.expenseAccount}`;
  if (payload?.partyIds) url += `&partyIds=${payload?.partyIds}`;

  const response = await authedAxios().get(url);
  return response;
};

const getForm2ReportService = async (endpoint, payload) => {
  const queryString = `report/form2?hotelId=${payload.hotelId}&startDate=${payload.startDate}${payload.endDate ? `&endDate=${payload.endDate}` : ''}`;
  const response = await authedAxios().get(queryString);
  return response;
};

export const getFeedbackReportService = async ({ hotelId, fromDate, toDate }) => {
  const queryString = `feedback/hotel/${hotelId}/all?startDate=${new Date(fromDate).toISOString()}&endDate=${new Date(toDate).toISOString()}`;
  const response = await authedAxios().get(queryString);
  return response;
};

export const getBookingsChangeReportService = async ({hotelId, fromDate, toDate}) => {
  const queryString = `report/bookings-change?hotelId=${hotelId}&startDate=${new Date(fromDate).toISOString()}&endDate=${new Date(toDate).toISOString()}`;
  const response = await authedAxios().get(queryString);
  return response;
}

export const getInvoiceChangeReportService = async ({hotelId, fromDate, toDate}) => {
  const queryString = `report/invoice-change?hotelId=${hotelId}&startDate=${new Date(fromDate).toISOString()}&endDate=${new Date(toDate).toISOString()}`;
  const response = await authedAxios().get(queryString);
  return response;
}

export const getPaymentChangeReportService = async ({hotelId, fromDate, toDate}) => {
  const queryString = `report/payment-change?hotelId=${hotelId}&startDate=${new Date(fromDate).toISOString()}&endDate=${new Date(toDate).toISOString()}`;
  const response = await authedAxios().get(queryString);
  return response;
}

export const getPgReportService = async (payload) => {
  let path = `report/pg-report?hotelId=${payload.hotelId}&startDate=${
    moment(new Date(payload.fromDate)).startOf('day').utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
  }&endDate=${moment(new Date(payload.toDate)).endOf('day').utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")}`;
  const response = await authedAxios().get(path);
  return response;
};

export const refundPgPaymentService = async (payload) => {
  const path = `payment-gateway/razorpay/refund?hotelId=${payload.hotelId}&paymentId=${payload.pgPaymentId}`;
  const response = await authedAxios().post(path, {});
  return response;
};

export const getRateReportService = async(payload) =>{
  let url = `report/revpar?hotelId=${payload.hotelId}`;
  if (payload?.startDate) url += `&startDate=${payload?.startDate}`;
  if (payload?.endDate) url += `&endDate=${payload?.endDate}`;
  const response = await authedAxios().get(url);
  return response;
}

export {
  getSettlementReportsService,
  getSaleReports,
  nightAuditReportService,
  getBookingListReportsService,
  getRoomChangeReportService,
  getOccupancyReportService,
  getSalesByCustomerReportService,
  getBookingSourceReportService,
  getTaxDetailsReportService,
  getPayableReportService,
  getReceivableReportService,
  getPaymentReportService,
  getVendorSummaryReportService,
  getForm2ReportService,
};
